import { render, staticRenderFns } from "./GapWarning.vue?vue&type=template&id=e96c9008&scoped=true"
import script from "./GapWarning.vue?vue&type=script&lang=ts"
export * from "./GapWarning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96c9008",
  null
  
)

export default component.exports